// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.footer-row button[data-v-1d21cb32] {\r\n  margin-left: 8px;\r\n  margin-bottom: 8px;\n}\n.footer-container[data-v-1d21cb32] {\r\n  z-index: 50;\n}\r\n", ""]);
// Exports
module.exports = exports;
